module.exports = __webpack_public_path__ + "img/office.5c355418.webp";